<template>
    <div class="sidebar_block">
        <div class="sidebar_title">
            {{ title || $t('articles.similarArticles') }}
        </div>

        <div class="similar_articles">
            <template v-for="topicType in allTopics">
                <similar-item-side-section
                    v-for="item in topicType.items"
                    :key="item.id"
                    :item="item"
                    :type="topicType.type"
                />
            </template>
        </div>
    </div>
</template>

<script>
import SimilarTopicsBase from './SimilarTopicsBase';
import SimilarItemSideSection from './SimilarItemSideSection';

export default {
    components: {
        SimilarItemSideSection
    },

    extends: SimilarTopicsBase
};
</script>
